const getAccessRestrictions = require('./getAccessRestrictions');
const config = require('./config');

function normalizeAction(action) {
    if (typeof action !== 'string') return action;
    const value = action.trim();
    if (!value) return value;

    if (['newFromTag', 'newAutoSerial'].includes(value)) return 'create';
    if (value === 'new' || value.startsWith('new_') || value.startsWith('new-')) return 'create';
    if (value === 'edit' || value.startsWith('edit_') || value.startsWith('edit-')) return 'update';

    if (value === 'create' || value.startsWith('create_') || value.startsWith('create-')) return 'create';
    if (value === 'update' || value.startsWith('update_') || value.startsWith('update-')) return 'update';

    if (value === 'remove' || value.startsWith('remove_') || value.startsWith('remove-')) return 'remove';

    if (value === 'view' || value.startsWith('view_') || value.startsWith('view-')) return 'read';
    if (value === 'read' || value.startsWith('read_') || value.startsWith('read-')) return 'read';

    return value;
}

function forActionFromShowForAction(showForAction) {
    const normalized = normalizeAction(showForAction);
    if (normalized === 'create' || normalized === 'update') return normalized;
    return undefined;
}

function buildAccessContextForAction(action, observedLocation) {
    const normalized = normalizeAction(action);

    return {
        get: { value: true, observedLocation },
        patch: { value: normalized !== 'create', observedLocation },
        post: { value: normalized !== 'update', observedLocation },
        put: { value: false, observedLocation },
        remove: { value: false, observedLocation }
    };
}

function buildWriteAccessContextForAction(action, observedLocation) {
    const normalized = normalizeAction(action);

    return {
        post: { value: normalized === 'create', observedLocation },
        patch: { value: normalized === 'update', observedLocation },
        remove: { value: normalized === 'remove', observedLocation }
    };
}

function getActionTarget(hNode = {}) {
    const rawAction = hNode.forAction ?? hNode.formAction;
    const normalizedAction = normalizeAction(rawAction);
    const subtype = hNode.subtype;
    const configuredTarget = config.actionSubtypeTargets?.[normalizedAction]?.[subtype];

    return {
        namespace: configuredTarget?.namespace ?? hNode.namespace,
        relation: configuredTarget?.relation ?? hNode.relation,
        action: configuredTarget?.action ?? normalizedAction
    };
}

function getNodeAccessRestrictions(hNode, context = {}, parentAccessRestrictions = {}) {
    const mergedSecurityModifiers = Object.assign({}, hNode, hNode?.securityModifier || {});
    return getAccessRestrictions(mergedSecurityModifiers, context, parentAccessRestrictions);
}

module.exports = {
    getActionTarget,
    normalizeAction,
    forActionFromShowForAction,
    buildAccessContextForAction,
    buildWriteAccessContextForAction,
    getNodeAccessRestrictions
};
